module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"addItems":"Add items","manageItems":"Manage items"},"fr_FR":{"addItems":"Ajouter des items","manageItems":"Gérer les items"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/i18n/components/user-box.json
// module id = 183
// module chunks = 1